module.exports = "<div ng-class=\"['tooltip-wrap', {opened: $ctrl.opened}]\" ng-transclude></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpTooltip/adpTooltip.html
// module id = 627
// module chunks = 0